import SectionButtonGroup from "../../../../../../components/Button/SectionButtonGroup";
import InfoWatchlistText from "./InfoWatchlistText";
import InfoSeqText from "./InfoSeqText";



export default function WatchlistButtonGroup() {

return(
<>      

<SectionButtonGroup

      button_1 = "IMPORTANT READ"
      button_2 = "SEQUENCING INFO"
      button_3 = "COUNSELING"
      
      title_dialog_1 = "Understanding Genetic Variants"
      content_dialog_1 = {<InfoWatchlistText />}
      
      title_dialog_2 = "Sequencing Information"
      content_dialog_2 = {<InfoSeqText />}

      to = "/Doctor"

/>

</>
)}